module.exports = __webpack_public_path__ + "static/bg10-628e19f9b9537d232c751e01af5dded4.jpg";